import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import axios from 'axios';
// API 基础 URL（不含 /api 后缀）
export const API_BASE_URL = process.env.REACT_APP_API || '';

// 创建Axios实例
const api = axios.create({
  baseURL: process.env.REACT_APP_API || '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  },
  withCredentials: true
});

// 初始化CSRF保护 - 添加这部分代码
const initializeCSRF = async () => {
  try {
    // 向Laravel Sanctum请求CSRF cookie
    await api.get('/sanctum/csrf-cookie');
    // console.log('CSRF cookie initialized successfully');
  } catch (error) {
    // console.error('Failed to initialize CSRF cookie:', error);
  }
};

// 应用启动时自动初始化
initializeCSRF();

// 从 cookie 中读取 CSRF token
function getCsrfTokenFromCookie() {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'XSRF-TOKEN') {
      return decodeURIComponent(value);
    }
  }
  return null;
}

// 请求拦截器
api.interceptors.request.use(config => {
  // 从localStorage获取token并添加到请求头
  const token = localStorage.getItem('token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // 从 cookie 中读取 CSRF token 并添加到请求头
  const csrfToken = getCsrfTokenFromCookie();
  if (csrfToken && config.headers) {
    config.headers['X-XSRF-TOKEN'] = csrfToken;
  }

  // 从localStorage获取当前公司ID并添加到请求头
  const companyId = localStorage.getItem('current_company_id');
  if (companyId && companyId !== 'null' && config.headers) {
    config.headers['X-Company-Id'] = companyId;
  }

  // 从localStorage获取init-lang并添加到accept-language请求头
  const initLang = localStorage.getItem('init-lang');
  if (initLang && config.headers) {
    // 将语言标识转换为后端期望的格式
    const acceptLanguage = initLang.replace('_', '-');
    config.headers['Accept-Language'] = acceptLanguage;
  }
  return config;
}, error => {
  console.error('请求错误:', error);
  return Promise.reject(error);
});

// 响应拦截器
api.interceptors.response.use(response => {
  // 统一处理响应数据
  const {
    data
  } = response;
  // 检查后端ApiResponse格式
  if (data.code >= 200 && data.code < 300) {
    // 成功响应，返回完整的data对象
    // console.log(response)
    return response;
  } else {
    // 错误响应
    console.error('操作失败:', data.message || '请求出错，请稍后重试');
    // 可替换为项目中的自定义提示组件
    _Message.error(data.message || '请求出错，请稍后重试');
    return Promise.reject(data);
  }
}, error => {
  // 统一处理错误
  if (error.response?.status === 401) {
    // 未授权，清除本地存储并跳转登录页
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    window.location.href = '/login';
    console.error('登录过期，请重新登录');
    _Message.error('登录过期，请重新登录');
  } else {
    // 从错误响应中提取消息
    const errorData = error.response?.data;
    const errorMessage = errorData?.message || error.message || '请求失败，请稍后重试';
    // 方法2: 提取具体字段的错误详情
    const errorDetails = errorData?.data?.errors;
    if (errorDetails) {
      // 将所有错误消息组合成一个字符串
      const detailedMessage = Object.values(errorDetails).flat().join('; ');
      _Message.error(`${errorMessage}: ${detailedMessage}`);
    } else {
      _Message.error(errorMessage);
    }
    // console.error('网络错误:', errorMessage);
  }
  return Promise.reject(error);
});

// 封装常用请求方法
export const request = {
  get: (url, config) => {
    return api.get(url, config);
  },
  post: (url, data, config) => {
    return api.post(url, data, config);
  },
  put: (url, data, config) => {
    return api.put(url, data, config);
  },
  delete: (url, config) => {
    return api.delete(url, config);
  },
  patch: (url, data, config) => {
    return api.patch(url, data, config);
  }
};
export default api;